module.exports = __webpack_public_path__ + "static/media/perkLab_phone-crop.db30e934.gif";